import React from 'react'
import { useNavigate } from 'react-router-dom'
import { t } from '@lingui/core/macro'
import { PaymentPageInfo } from '../../types/paymentPageInfo'
import ArrowButton from '../ArrowButton/ArrowButton'
import ErrorStatusIcon from '../StatusIcon/ErrorStatusIcon'
import MerchantSiteRedirectButton from '../MerchantSiteRedirectButton/MerchantSiteRedirectButton'
import styles from '../../pages/PaymentResultPage/PaymentResultPage.module.css'

interface PaymentErrorProps {
    paymentPageInfo: PaymentPageInfo
    removePaymentError: () => void
}

const PaymentError = ({ paymentPageInfo, removePaymentError }: PaymentErrorProps) => {
    const navigate = useNavigate()

    const handleRetryPayment = () => {
        removePaymentError()

        navigate(`/payment/${paymentPageInfo.id}`)
    }

    return (
        <div className={styles.section}>
            <ErrorStatusIcon />

            <h1 className={styles.title}>{t`Ошибка`}</h1>
            <p className={styles.description}>{t`К сожалению, платеж не может быть выполнен. Попробуйте другой способ оплаты.`}</p>

            <div className={styles.alternative}>
                <ArrowButton
                    icon="💳"
                    name={t`Попробовать другой способ`}
                    onClick={handleRetryPayment}
                    disabled={false}
                />
            </div>

            <MerchantSiteRedirectButton
                redirectUrl={paymentPageInfo?.redirectUrl}
                redirectTimeout={paymentPageInfo?.redirectTimeout}
            />
        </div>
    )
}

export default PaymentError
